import {Component, OnDestroy, OnInit} from '@angular/core';
import {DashboardBoxesHeadData} from "../../interfaces/dashboard-boxes-head-data";
import {GamesService} from "../../services/games.service";
import {Game} from "../../interfaces/game";
import {DataService} from "../../services/data.service";
import {StudentAuthService} from "../../services/student-auth.service";
import {take} from "rxjs";
import {WatchDataService} from "../../services/watch-data.service";

@Component({
  selector: 'brt-games-list',
  templateUrl: './games-list.component.html',
  styleUrls: ['./games-list.component.scss']
})
export class GamesListComponent implements OnInit, OnDestroy {
  headlineData: Partial<DashboardBoxesHeadData> = {
    title: "Spiele",
    titleIcon: "games",
    hintIcon: "time",
    color: "cyan",
    addHintPulseCircle: false

  };

  games: Game[] = [];

  hasQuizCategories = true;
  hasClickThePicCategories = true;

  gameCategoriesRefreshInterval: any;

  constructor(
    private gamesService: GamesService,
    private data: DataService,
    private watchDataService: WatchDataService,
    private studentAuth: StudentAuthService
  ) {
  }
  ngOnInit() {

    this.games = this.gamesService.getGames();

    const clientId = localStorage.getItem('clientId');
    if(clientId) {

      this.watchDataService.getGameCategoriesPerGame(clientId);

      this.gameCategoriesRefreshInterval = setInterval(() => {
        this.watchDataService.getGameCategoriesPerGameQuery?.refetch();
      }, 10000);

      this.watchDataService.getGameCategoriesPerGameSubject.subscribe(response => {

        if(!response) {
          return;
        }

        this.hasQuizCategories = response.quiz > 0;
        this.hasClickThePicCategories = response.guessTheJob > 0;

        this.games[0].properties.isAvailable = this.hasQuizCategories;
        this.games[1].properties.isAvailable = this.hasClickThePicCategories

      });
    }

    const entryCode = this.studentAuth.getClassData().classCode;
    this.data.getSchoolClassGameHistory(entryCode).pipe(take(1)).subscribe((data) => {
      if(data && data.length) {
        const lastEntry = data[0];
        const playedTime = lastEntry.playtime ?? 0;

        const SECONDS_IN_HOUR = 3600;
        const SECONDS_IN_MINUTE = 60;

        // 1. Calculate the total whole hours
        const totalHours = Math.floor(playedTime / SECONDS_IN_HOUR);
        
        // 2. Calculate the remaining seconds after hours are accounted for
        const remainingSeconds = playedTime % SECONDS_IN_HOUR;

        // 3. Calculate the whole minutes from the remaining seconds
        const totalMinutes = Math.floor(remainingSeconds / SECONDS_IN_MINUTE);

        let playedTimeString = "";
        if(totalHours > 0) {
          playedTimeString += `${totalHours} Std.`;
        }
        playedTimeString += ` ${totalMinutes} Min.`;
        playedTimeString += " bisher gespielt";
        playedTimeString = playedTimeString.trim();

        this.headlineData = {
          ...this.headlineData,
          hint: playedTimeString
        }
      }
    });

  }

  ngOnDestroy() {
    if(this.gameCategoriesRefreshInterval) {
      clearInterval(this.gameCategoriesRefreshInterval);
    }
  }

}
